/**
 * Selects a parent Flex element, up to n levels up.
 *
 * Args:
 *      startingElement (FlexElement): The element you want to find a parent for.
 *      numLevels (Number): The number of levels, e.g. pass 2 for the "grandparent".
 *
 * Returns:
 *      (FlexElement | null): Returns the parent Flex element that was found, otherwise null.
 *
 * Example:
 *      getParentElement(this); // gets the parent Flex element
 *      getParentElement(this, 2) // gets the "grandparent" Flex element
 *
 */
export default function getParentElement(startingElement, numLevels = 1) {
    let currentElement = startingElement;
    let isFlexComponent = false;
    let currentLevel = 1;

    while (!isFlexComponent || currentLevel <= numLevels) {
        currentElement = currentElement.$parent;

        if (!currentElement.$parent) return null;

        if (currentElement.templateType) {
            isFlexComponent = true;
            currentLevel++;
        } else {
            isFlexComponent = false;
        }
    }

    if (
        currentElement.elementType === 'flex-placeholder'
        || (currentElement.elementType === 'drop-zone-multi' && !currentElement.isLayoutComponent)
    ) {
        return null;
    }

    return currentElement;
}
